import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';
import { useCallback } from 'react';

const FETCH_SAVED_EVENT_SLUGS = gql`
  query userBookmarks($anchorGuid: String, $pageSize: Int) {
    paginatedUserBookmarks(
      type: "event"
      anchorGuid: $anchorGuid
      pageSize: $pageSize
    ) {
      slug
      guid
    }
  }
`;

export const useFetchSavedEventSlugs = () => {
  return useCallback(async (anchorGuid: string | null, pageSize: number) => {
    const result = await graphql.query<{
      paginatedUserBookmarks: { slug: string; guid: string }[];
    }>({
      query: FETCH_SAVED_EVENT_SLUGS,
      variables: { anchorGuid, pageSize: pageSize },
      fetchPolicy: 'no-cache',
    });
    return {
      bookmarks: result.data.paginatedUserBookmarks.map((item) => ({
        guid: item.guid,
        slug: decodeURI(item.slug),
      })),
      hasLoadMore: result.data.paginatedUserBookmarks.length === pageSize,
    };
  }, []);
};
